import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import React, { useEffect } from 'react';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import Proptypes from 'prop-types';

export const MoneyFlowLottie = ({ src, isAbsolute }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (<LottieControl
    onLoadSuccess={() => setIsContentShowing(true)}
    onLoadError={() => setIsContentShowing(true)}
    src={src}
    height={'100%'}
    width={'100%'}
    position={isAbsolute ? 'absolute' : undefined}
  />);
};

MoneyFlowLottie.defaultProps = {
  isAbsolute: false,
};

MoneyFlowLottie.propTypes = {
  src: Proptypes.string.isRequired,
  isAbsolute: Proptypes.bool,
};
